<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'TerminationContractPage',

};
</script>

<style>

</style>
